var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"my-4 text-center"},[_vm._v(" This page will display all hotel offers (such as discounted extended stays, spa and massage), and local offers are provided by the local businesses in the same hotel area. ")])}
var staticRenderFns = []

export { render, staticRenderFns }